export default __webpack_public_path__ + "003a7528f1bb6a44fd831485ccc2269f.png";